import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'
import reducer from './reducer'
import initialState from "./initialState";
import { applyMiddleware, createStore } from 'redux'

const cachedStore = {...initialState};
var middlewareArray = [promise(), thunk]
var middleware = applyMiddleware(...middlewareArray)
var store = createStore(reducer, cachedStore, middleware)

export default store;